import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[forceUppercase]'
})
export class ForceUppercaseDirective {
  @Input()
  forceUppercase: {
    currentValue?: string;
    dotSeperator: boolean;
    firstLetterOnly: boolean;
  } = {
    dotSeperator: false,
    firstLetterOnly: false
  };

  // tslint:disable
  @HostListener('input', ['$event'])
  onInputChange(event: InputEventWrapper): void {
    const { target } = event;
    const { value } = target;

    const { dotSeperator, firstLetterOnly, currentValue } = this.forceUppercase;

    event.target.value = value
      ? firstLetterOnly
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : value.toUpperCase()
      : value;

    if (!dotSeperator) return;

    const withDots = value
      .split('')
      .filter(letter => letter !== '.')
      .join('.');

    const letters = `${
      firstLetterOnly
        ? withDots.charAt(0).toUpperCase() + '.' + value.slice(1)
        : withDots.toUpperCase()
    }${withDots.split('').length ? '.' : ''}`;

    event.target.value = currentValue === letters ? value : letters;
  }
}
